var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSegments = function SvgSegments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 363,
    height: 131
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "segments_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6089",
    fill: "none",
    d: "M0 0h321.977v115.727H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "segments_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25858",
    d: "M150.393 58.332a43.135 43.135 0 0 0 10.6 28.367 43.269 43.269 0 0 0 0-56.734 43.137 43.137 0 0 0-10.6 28.367",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12108"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12105"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12104",
    clipPath: "url(#segments_svg__a)",
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25735",
    d: "M260.424 32.871a9.762 9.762 0 1 1-9.761 9.761 9.761 9.761 0 0 1 9.761-9.761",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1023",
    cx: 2.898,
    cy: 2.898,
    r: 2.898,
    transform: "rotate(-76.717 155.732 -140.853)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25736",
    d: "M256.9 47.243a3.524 3.524 0 0 1 3.62-3.425",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25737",
    d: "M264.142 47.243a3.524 3.524 0 0 0-3.62-3.425",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25738",
    d: "M278.818 38.2h39.205a4.467 4.467 0 0 1 0 8.874h-39.205a4.467 4.467 0 0 1 0-8.874",
    fill: "#e1e5f8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25739",
    d: "M260.424 59.084a9.762 9.762 0 1 1-9.761 9.761 9.761 9.761 0 0 1 9.761-9.761",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1024",
    cx: 2.898,
    cy: 2.898,
    r: 2.898,
    transform: "rotate(-74.196 174.18 -135.316)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25740",
    d: "M256.9 73.456a3.524 3.524 0 0 1 3.62-3.425",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25741",
    d: "M264.142 73.456a3.524 3.524 0 0 0-3.62-3.425",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25742",
    d: "M278.818 64.408h39.205a4.467 4.467 0 0 1 0 8.874h-39.205a4.467 4.467 0 0 1 0-8.874",
    fill: "#e1e5f8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25743",
    d: "M260.424 85.3a9.762 9.762 0 1 1-9.761 9.761 9.761 9.761 0 0 1 9.761-9.761",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1025",
    cx: 2.898,
    cy: 2.898,
    r: 2.898,
    transform: "rotate(-74.439 191.247 -121.462)",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25744",
    d: "M256.9 99.668a3.524 3.524 0 0 1 3.62-3.425",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25745",
    d: "M264.142 99.668a3.524 3.524 0 0 0-3.62-3.425",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25746",
    d: "M278.818 90.621h39.205a4.467 4.467 0 0 1 0 8.874h-39.205a4.467 4.467 0 0 1 0-8.874",
    fill: "#e1e5f8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25747",
    d: "M71.315 19.543a9.762 9.762 0 1 1-9.761-9.761 9.761 9.761 0 0 1 9.761 9.761",
    fill: "#2d2f7a"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1026",
    cx: 2.898,
    cy: 2.898,
    r: 2.898,
    transform: "translate(58.558 14.932)",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25748",
    d: "M61.455 20.728a3.525 3.525 0 0 1 3.62 3.425",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25749",
    d: "M61.455 20.728a3.525 3.525 0 0 0-3.62 3.425",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25750",
    d: "M47.113 19.543a4.217 4.217 0 0 1-3.954 4.437H3.954A4.217 4.217 0 0 1 0 19.543a4.217 4.217 0 0 1 3.954-4.437h39.205a4.217 4.217 0 0 1 3.954 4.437",
    fill: "#e1e5f8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25751",
    d: "M71.315 45.755a9.762 9.762 0 1 1-9.761-9.761 9.761 9.761 0 0 1 9.761 9.761",
    fill: "#2d2f7a"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1027",
    cx: 2.898,
    cy: 2.898,
    r: 2.898,
    transform: "translate(58.558 41.145)",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25752",
    d: "M61.455 46.94a3.525 3.525 0 0 1 3.62 3.425",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25753",
    d: "M61.455 46.94a3.525 3.525 0 0 0-3.62 3.425",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25754",
    d: "M47.113 45.755a4.217 4.217 0 0 1-3.954 4.437H3.954A4.217 4.217 0 0 1 0 45.755a4.217 4.217 0 0 1 3.954-4.437h39.205a4.217 4.217 0 0 1 3.954 4.437",
    fill: "#e1e5f8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25755",
    d: "M71.315 71.968a9.762 9.762 0 1 1-9.761-9.761 9.761 9.761 0 0 1 9.761 9.761",
    fill: "#2d2f7a"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1028",
    cx: 2.898,
    cy: 2.898,
    r: 2.898,
    transform: "translate(58.558 67.358)",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25756",
    d: "M61.455 73.153a3.525 3.525 0 0 1 3.62 3.425",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25757",
    d: "M61.455 73.153a3.525 3.525 0 0 0-3.62 3.425",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.887
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25758",
    d: "M47.113 71.968a4.217 4.217 0 0 1-3.954 4.432H3.954a4.467 4.467 0 0 1 0-8.874h39.205a4.217 4.217 0 0 1 3.954 4.437",
    fill: "#e1e5f8"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6087",
    width: 9.91,
    height: 9.91,
    rx: 1.712,
    transform: "translate(226.362 94.931)",
    fill: "none",
    stroke: "#e1e5f8",
    strokeMiterlimit: 10,
    strokeWidth: 2.282
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6088",
    d: "M212.364 109.404h3.711a.979.979 0 0 1 .979.979v3.711a.98.98 0 0 1-.98.98h-3.71a.979.979 0 0 1-.979-.979v-3.712a.979.979 0 0 1 .979-.979Z",
    fill: "none",
    stroke: "#e1e5f8",
    strokeMiterlimit: 10,
    strokeWidth: 1.306
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25759",
    d: "M82.281 10.98A4.921 4.921 0 1 1 87.2 15.9a4.921 4.921 0 0 1-4.921-4.921",
    fill: "#e1e5f8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25760",
    d: "M99.872 2.578a2.577 2.577 0 1 1 2.578 2.578 2.578 2.578 0 0 1-2.578-2.578",
    fill: "#e1e5f8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25761",
    d: "M84.944 58.332a43.32 43.32 0 1 1 43.32 43.32 43.32 43.32 0 0 1-43.32-43.32",
    fill: "#2d2f7a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25762",
    d: "M171.584 58.332a43.142 43.142 0 0 1-10.6 28.367 43.32 43.32 0 1 0 0-56.734 43.142 43.142 0 0 1 10.6 28.367",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25763",
    d: "M160.989 85.334a42.386 42.386 0 0 1 0-54 42.386 42.386 0 0 1 0 54",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25764",
    d: "M160.988 32.738a41.505 41.505 0 0 1 0 51.189 41.505 41.505 0 0 1 0-51.189m0-2.773a43.274 43.274 0 0 0 0 56.735 43.274 43.274 0 0 0 0-56.735",
    fill: "#2d2f7a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25765",
    d: "M115.915 58.465a1.424 1.424 0 1 1-1.424 1.424 1.424 1.424 0 0 1 1.424-1.424Z",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.737
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25766",
    d: "M114.178 64.545a1.424 1.424 0 1 1-1.424 1.424 1.424 1.424 0 0 1 1.424-1.424Z",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.737
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25767",
    d: "M127.193 51.226c3.9 3.9 5.414 8.714 3.378 10.749s-6.848.523-10.749-3.378-5.413-8.714-3.378-10.749 6.848-.523 10.749 3.378Z",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.737
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 232",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeWidth: 1.737,
    d: "m129.592 62.52-21.159 7.465"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 233",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.737,
    d: "m113.169 54.194-4.735 15.791"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25768",
    d: "m133.271 44.931 1.513-.5 1.514.5-.505-1.513.507-1.518-1.514.5-1.513-.5.5 1.514Z",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25769",
    d: "m134.5 53.53 1.513-.5 1.514.5-.505-1.513.505-1.514-1.514.5-1.513-.5.5 1.514Z",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25770",
    d: "m123.524 43.985 2.523-.841 2.522.841-.841-2.523.841-2.522-2.522.841-2.523-.841.841 2.522Z",
    fill: "#81e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25771",
    d: "M189.627 48.468v15.526h5.391a2.505 2.505 0 0 1 2.5 2.505V48.025a6.223 6.223 0 0 0-7.891.443Z",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.737
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25772",
    d: "M197.522 48.025a6.221 6.221 0 0 1 7.9.443v15.525h-5.391a2.506 2.506 0 0 0-2.5 2.506",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.737
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25773",
    d: "M205.416 48.468h2.784V66.96h-7.8a2.884 2.884 0 0 1-5.768 0h-7.795V48.468h2.782",
    fill: "none",
    stroke: "#2d2f7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.737
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12107"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12106",
    clipPath: "url(#segments_svg__b)",
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12145",
    fill: "#2d2f7a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25774",
    d: "M144.535 35.116a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25775",
    d: "M147.442 38.99a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25776",
    d: "M153.252 38.99a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25777",
    d: "M159.063 38.99a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25778",
    d: "M164.873 38.99a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25779",
    d: "M170.683 38.99a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25780",
    d: "M176.493 38.99a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25781",
    d: "M150.347 35.116a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25782",
    d: "M156.157 35.116a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25783",
    d: "M161.968 35.116a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25784",
    d: "M167.778 35.116a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25785",
    d: "M173.588 35.116a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25786",
    d: "M144.535 42.863a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25787",
    d: "M147.442 46.737a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25788",
    d: "M153.252 46.737a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25789",
    d: "M159.063 46.737a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25790",
    d: "M164.873 46.737a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25791",
    d: "M170.683 46.737a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25792",
    d: "M176.493 46.737a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25793",
    d: "M150.347 42.863a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25794",
    d: "M156.157 42.863a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25795",
    d: "M161.968 42.863a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25796",
    d: "M167.778 42.863a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25797",
    d: "M173.588 42.863a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25798",
    d: "M144.535 50.61a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25799",
    d: "M147.442 54.484a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25800",
    d: "M153.252 54.484a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25801",
    d: "M159.063 54.484a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25802",
    d: "M164.873 54.484a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25803",
    d: "M170.683 54.484a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25804",
    d: "M176.493 54.484a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25805",
    d: "M150.347 50.61a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25806",
    d: "M156.157 50.61a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25807",
    d: "M161.968 50.61a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25808",
    d: "M167.778 50.61a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25809",
    d: "M173.588 50.61a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25810",
    d: "M144.535 58.357a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25811",
    d: "M147.442 62.231a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25812",
    d: "M153.252 62.231a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25813",
    d: "M159.063 62.231a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25814",
    d: "M164.873 62.231a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25815",
    d: "M170.683 62.231a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25816",
    d: "M176.493 62.231a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25817",
    d: "M150.347 58.357a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25818",
    d: "M156.157 58.357a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25819",
    d: "M161.968 58.357a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25820",
    d: "M167.778 58.357a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25821",
    d: "M173.588 58.357a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25822",
    d: "M144.535 66.1a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25823",
    d: "M147.442 69.978a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25824",
    d: "M153.252 69.978a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25825",
    d: "M159.063 69.978a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25826",
    d: "M164.873 69.978a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25827",
    d: "M170.683 69.978a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25828",
    d: "M176.493 69.978a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25829",
    d: "M150.347 66.1a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25830",
    d: "M156.157 66.1a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25831",
    d: "M161.968 66.1a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25832",
    d: "M167.778 66.1a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25833",
    d: "M173.588 66.1a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25834",
    d: "M144.535 73.851a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25835",
    d: "M147.442 77.725a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25836",
    d: "M153.252 77.725a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25837",
    d: "M159.063 77.725a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25838",
    d: "M164.873 77.725a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25839",
    d: "M170.683 77.725a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25840",
    d: "M176.493 77.725a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25841",
    d: "M150.347 73.851a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25842",
    d: "M156.157 73.851a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25843",
    d: "M161.968 73.851a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25844",
    d: "M167.778 73.851a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25845",
    d: "M173.588 73.851a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25846",
    d: "M144.535 81.6a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25847",
    d: "M147.442 85.472a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25848",
    d: "M153.252 85.472a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25849",
    d: "M159.063 85.472a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25850",
    d: "M164.873 85.472a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25851",
    d: "M170.683 85.472a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25852",
    d: "M176.493 85.472a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25853",
    d: "M150.347 81.6a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25854",
    d: "M156.157 81.6a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25855",
    d: "M161.968 81.6a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25856",
    d: "M167.778 81.6a.968.968 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25857",
    d: "M173.588 81.6a.969.969 0 1 1-.968-.968.968.968 0 0 1 .968.968"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7966",
    fill: "none",
    d: "M0 0h363v131H0z"
  })));
};
export default SvgSegments;